import { Box, Button, LoadingOverlay, Paper, Select, SimpleGrid, Space, Switch, Text, Textarea, TextInput, Title } from '@mantine/core';
import React, { memo, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import useFetch from '../../../../Customhooks/useFetch';
import { baseUrl } from '../../../../Constants/constant';
import classes from '../ManageFactory.module.css';
import FactoryCharacteristics from './FactoryCharacteristics/FactoryCharacteristics.component';
import LocationAutocomplete from '../../../../CustomComponent/LocationAutocomplete';

interface FormField {
    id_comp: number;
    id: number | null;
    process_name: string;
    percentage_of_factory: string;
}

interface ProductForm {
    factory_name: string;
    // factory_id: string;
    // country_id: number;
    factory_address: number,
    place_id: string,
    sessiontoken?: any,
    location_based_emission: string,
    fuel_based_emission: string,
    market_based_emission: string,
    processes: Array<{
        id: number | null;
        process_name: string;
        percentage_of_factory: string;
    }>;
}

const AddFactory = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const token = localStorage.getItem("token") || "";
    const [location, setLocation] = useState<any>();
    const [factoryName, setFactoryName] = useState('');
    // const [factoryId, setFactoryId] = useState('');
    const [locationemissions, setLocationEmissions] = useState<string>('');
    const [fuelemissions, setFuelEmissions] = useState<string>('');
    const [marketemissions, setMarketEmissions] = useState<string>('');
    const [formData, setFormData] = useState<FormField[]>([]);
    const [isValid, setIsValid] = useState(false);
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [requestData, setRequestData] = useState<ProductForm | null>(null);
    const [showErrors, setShowErrors] = useState(false);
    const [pathId, setPathId] = useState<string>('');
    const [checked, setChecked] = useState(false);
    const [initialProductCharacteristics, setInitialProductCharacteristics] = useState<FormField[]>([]);
    // const [countries, setCountries] = useState<any>();
    // const [selectedCountries, setSelectedCountries] = useState<any>();

    // Fetch product data hook

    const fetchConfig = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
    };

    const { data: getDaatafactoryid, loading: fetchFactoryLoading, error, fetchData: fetchFactoryDetails } = useFetch(fetchConfig);
    const { data: getData, fetchData: getCountries } = useFetch(fetchConfig);
    // Save/Update product hook
    const {
        data: factoryData,
        error: factoryError,
        loading: factoryLoading,
        fetchData: postFactory
    } = useFetch({
        method: id ? 'PUT' : 'POST',
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
        body: requestData ? JSON.stringify(requestData) : undefined
    });
    useEffect(() => {
        getCountries(`${baseUrl}admin/countries`);
    }, []);
    // useEffect(() => {
    //     if (getData?.data) {
    //         setCountries(
    //             getData.data.map((el: any) => ({
    //                 value: el?.id.toString(),
    //                 label: el?.nice_name,
    //             }))
    //         );
    //     }
    // }, [getData]);
    // Fetch product data if editing
    useEffect(() => {
        if (!id) return;
        fetchFactoryDetails(`${baseUrl}admin/factories/${id}`);
    }, [id]);
    useEffect(() => {
        if (!getDaatafactoryid) return;
        if (getDaatafactoryid?.data) {
            setFactoryName(getDaatafactoryid?.data?.rows[0]?.factory_name);
            // setFactoryId(getDaatafactoryid?.data?.rows[0]?.factory_id);
            setLocation(getDaatafactoryid?.data?.rows[0]?.factory_address);
            setLocationEmissions(getDaatafactoryid?.data?.rows[0]?.location_based_emission);
            setFuelEmissions(getDaatafactoryid?.data?.rows[0].fuel_based_emission);
            setMarketEmissions(getDaatafactoryid?.data?.rows[0].market_based_emission);
            setPathId(getDaatafactoryid?.data?.rows[0].place_id);
            // if (countries?.length > 0 && getDaatafactoryid?.data) {
            //     const matchingLocation = countries.find(
            //         (v: any) => v.value === getDaatafactoryid?.data?.rows[0]?.country_id.toString()
            //     );
            //     setSelectedCountries(matchingLocation?.value || null);
            // }
            if (getDaatafactoryid?.data?.rows[0]?.FactoryProcesses) {
                const transformedFields = getDaatafactoryid?.data?.rows[0]?.FactoryProcesses?.map((char: any, index: number) => ({
                    id_comp: index + 1,
                    ...(char.id ? { id: char?.id } : {}),
                    process_name: char?.process_id,
                    percentage_of_factory: char?.percentage_of_factory,
                }));

                setInitialProductCharacteristics(transformedFields);
                setFormData(transformedFields);
            }
        }
    }, [getDaatafactoryid]);

    const showNotification = (type: 'success' | 'error', message: string) => {
        notifications.show({
            title: type === 'success' ? 'Success' : 'Error',
            message,
            color: type === 'success' ? 'green' : 'red',
            classNames: classes,
        });
    };

    const handleFieldsChange = (fields: FormField[]) => {
        setFormData(fields);
    };

    const handleValidationChange = (valid: boolean) => {
        setIsValid(valid);
    };

    const handleChange = (field: string, value: string | null) => {
        if (field === "factory_name") {
            setFactoryName(value as string);
        }
        // else if (field === "countries") {
        //     setSelectedCountries(value);
        // }
        else if (field === "location") {
            setLocation(value || '');
        }
        else if (field === "location_emissions") {
            setLocationEmissions(value as string);
        }
        else if (field === "fuel_emissions") {
            setFuelEmissions(value as string);
        }
        else if (field === "market_emissions") {
            setMarketEmissions(value as string);
        }

        // Remove the error for the field if it's being updated
        setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    };

    // Handle location change with place_id from LocationAutocomplete
    const handleLocationChange = (value: string | null, placeId?: string) => {
        setLocation(value || '');
        setPathId(placeId || '');
        setErrors((prev: any) => ({ ...prev, location: undefined }));
    };

    const validateForm = (): boolean => {
        let newErrors: Record<string, string> = {};

        if (!factoryName) {
            newErrors.factory_name = 'Factory name is required';
        }
        // if (!factoryId) {
        //     newErrors.factory_id = 'Factory Id is required';
        // }
        if (!location) {
            newErrors.geo_location = 'location is required';
        }
        // if (!selectedCountries) {
        //     newErrors.countries = 'Country is required';
        // }
        // if (!locationemissions) {
        //     newErrors.location_emissions = "Location Based Emission is Required";
        // }
        if (!fuelemissions) {
            newErrors.fuel_emissions = "Fuel Based Emission is Required";
        }
        // if (!marketemissions) {
        //     newErrors.market_emissions = "Market Based Emission is Required";
        // }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false; // Validation failed
        }
        return true; // Validation passed
    };

    const handleSave = async () => {
        setShowErrors(true); // Show errors when save is clicked

        if (!validateForm()) {
            showNotification('error', 'Please fill all required fields');
            return;
        }
        if (!isValid) {
            showNotification('error', 'Please fill all required fields');
            return;
        }

        const data: ProductForm = {
            factory_name: factoryName,
            // factory_id: factoryId,
            // country_id: selectedCountries,
            factory_address: location,
            place_id: pathId,
            location_based_emission: locationemissions,
            fuel_based_emission: fuelemissions,
            market_based_emission: marketemissions,

            processes: formData.map(field => {
                const componentData: any = {
                    // country_id: field.country,
                    process_id: field.process_name,
                    percentage_of_factory: field.percentage_of_factory,
                };
                if (field.id) {
                    componentData.id = field.id;
                }
                return componentData;
            })
        };

        setRequestData(data);
    };
    useEffect(() => {
        const makeApiCall = async () => {
            if (requestData) {
                const url = id ? `${baseUrl}admin/factories/update/${id}` : `${baseUrl}admin/factories/add`;
                await postFactory(url);
            }
        };

        makeApiCall();
    }, [requestData]);

    useEffect(() => {
        const showNotification = (type: any, title = "An error occurred") => {
            notifications.show({
                title,
                message: type === 'success'
                    ? "Transport data saved successfully."
                    : "Something went wrong. Please try again.",
                color: type === 'success' ? "green" : "red",
                classNames: classes,
            });
        };

        if (factoryData?.errors || factoryError) {
            showNotification('error', factoryData?.message || factoryError?.message);
            return;
        }

        if (factoryData && !factoryData?.errors) {
            navigate('/manage-factory');
        }
    }, [factoryData, factoryError, navigate, classes]);

    return (
        <>
            <LoadingOverlay
                visible={fetchFactoryLoading}
                zIndex={1000}
                overlayProps={{
                    radius: 'sm',
                    blur: 2,
                    style: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                }}
                loaderProps={{ color: '#404040', type: 'bars' }}
            />
            <Paper shadow="xs" p="xs" radius="md">
                <Box ml={5}>
                    <Title order={4}>{id ? 'Edit Factory' : 'Add Factory'}</Title>
                    <Space h="lg" />
                    <Box>
                        <Switch
                            checked={checked}
                            onChange={(e) => {
                                const val = e.currentTarget.checked;
                                setChecked(val);
                            }}
                            style={{float:'right'}}
                            label={checked ? "Lat Lng Input On" : "Lat Lng Input Off"}
                            mb={4}
                        />
                    <Text>Factory Details</Text>
                    <Space h="xs" />
                    </Box>
                    <SimpleGrid cols={4}>
                        {/* <Select
                            label="Country"
                            placeholder="Choose City"
                            variant="filled"
                            withAsterisk
                            data={countries}
                            searchable
                            maxDropdownHeight={200}
                            value={selectedCountries}
                            onChange={(value) => handleChange("countries", value)}
                            radius={6}
                            error={errors.countries}
                        /> */}
                        <LocationAutocomplete
                            label="Location"
                            placeholder="Enter your location"
                            withAsterisk
                            value={location}
                            onChange={handleLocationChange}
                            error={errors.location}
                            latLngMode={checked}
                        />
                        <TextInput
                            value={factoryName}
                            onChange={(e) => handleChange("factory_name", e.target.value)}
                            // onChange={(e) => setFactoryName(e.target.value)}
                            label="Factory Name"
                            variant="filled"
                            withAsterisk
                            placeholder="Enter factory name"
                            radius={6}
                            error={errors.factory_name}
                        />
                        {/* <TextInput
                            value={factoryId}
                            onChange={(e) => handleChange("factory_id", e.target.value)}
                            // onChange={(e) => setFactoryId(e.target.value)}
                            label="Factory ID"
                            variant="filled"
                            withAsterisk
                            placeholder="Enter factory Id"
                            radius={6}
                            error={errors.factory_id}
                        /> */}
                        <TextInput
                            value={locationemissions}
                            onChange={(e) => handleChange("location_emissions", e.target.value)}
                            label="Location Based Emissions (g)"
                            variant='filled'
                            withAsterisk
                            placeholder="g 0.00"
                            radius={6}
                            // error={errors.location_emissions}
                        />
                        <TextInput
                            value={fuelemissions}
                            onChange={(e) => handleChange("fuel_emissions", e.target.value)}
                            label="Fuel Based Emissions (g)"
                            variant='filled'
                            withAsterisk
                            placeholder="g 0.00"
                            radius={6}
                            error={errors.fuel_emissions}
                        />
                        <TextInput
                            value={marketemissions}
                            onChange={(e) => handleChange("market_emissions", e.target.value)}
                            label="Market Based Emissions (g)"
                            variant='filled'
                            withAsterisk
                            placeholder="g 0.00"
                            radius={6}
                            // error={errors.market_emissions} 
                            />
                    </SimpleGrid>
                    <Space h="lg" />
                    <FactoryCharacteristics
                        onFieldsChange={handleFieldsChange}
                        onValidationChange={handleValidationChange}
                        showErrors={showErrors}
                        initialFields={initialProductCharacteristics}

                    />
                    <Space h="sm" />
                    <SimpleGrid cols={6}>
                        <Button
                            variant="default"
                            radius={6}
                            onClick={() => navigate('/manage-factory')}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="gradient"
                            gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                            radius={6}
                            onClick={handleSave}
                            loading={factoryLoading}
                            disabled={factoryLoading}
                        >
                            {id ? 'Update' : 'Save'}
                        </Button>
                    </SimpleGrid>
                </Box>
            </Paper>
        </>
    );
};

export default memo(AddFactory);